/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { PublicPageContent, Typography, WithGap } from '@/components'
import { isString } from '@/utils'
import { Container } from './styles'
import { useTranslation } from 'react-i18next'

type NestedString = string | NestedString[]

type TermsContentItem = {
  title: string
  content: NestedString
}

type TermsContent = TermsContentItem[]

export const Terms = () => {
  const { t } = useTranslation()
  const whatWeDoPartOne = (t('terms.whatWeDo.content', {
    returnObjects: true,
  })[1] as unknown) as string[]

  const termsContent = t('terms.content', {
    returnObjects: true,
  }) as TermsContent

  return (
    <PublicPageContent>
      <Container>
        <WithGap gap={4}>
          <Typography responsive variant="h1">
            {t('terms.title')}
          </Typography>
          <Typography responsive variant="h3">
            {t('terms.whoAreWe.title')}
          </Typography>
          <Typography variant="p1Body">
            {t('terms.whoAreWe.content')}
          </Typography>
          <Typography responsive variant="h3">
            {t('terms.whatWeDo.title')}
          </Typography>
          <Typography variant="p1Body">
            {t('terms.whatWeDo.content[0]')}
          </Typography>
          <ul>
            {whatWeDoPartOne.map((text: string, i: number) => (
              <li key={i}>
                <Typography variant="p1Body">{text}</Typography>
              </li>
            ))}
          </ul>
          <Typography variant="p1Body">
            {t('terms.whatWeDo.content', { returnObjects: true })[2]}
          </Typography>
          {termsContent.map(({ title, content }, i: number) => (
            <>
              <Typography responsive variant="h3">
                {i + 1} {title}
              </Typography>
              {isString(content) ? (
                <Typography variant="p1Body">{content}</Typography>
              ) : (
                content.map((item, j: number) =>
                  isString(item) ? (
                    <Typography variant="p1Body">
                      {i + 1}.{j + 1} {item}
                    </Typography>
                  ) : (
                    item.map((subitem, k: number) =>
                      k === 0 ? (
                        <Typography variant="p1Body">
                          {i + 1}.{j + 1} {subitem}
                        </Typography>
                      ) : isString(subitem) ? (
                        <Typography variant="p1Body">{subitem}</Typography>
                      ) : (
                        <ul>
                          {subitem.map((listItem, l: number) =>
                            isString(listItem) ? (
                              <li key={l}>
                                <Typography variant="p1Body">
                                  {listItem}
                                </Typography>
                              </li>
                            ) : (
                              <ul>
                                {listItem.map((sublistItem, m: number) => (
                                  <li key={m}>
                                    <Typography variant="p1Body">
                                      {sublistItem}
                                    </Typography>
                                  </li>
                                ))}
                              </ul>
                            ),
                          )}
                        </ul>
                      ),
                    )
                  ),
                )
              )}
            </>
          ))}
        </WithGap>
      </Container>
    </PublicPageContent>
  )
}
